import React from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import Layouts from '../layouts/Layouts';
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material';

const Kpi = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Layouts>
            <div>
                <h1>KEY PERFORMACE INDICATOR ( KPI )</h1>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/kpi/indicator/data`} className={` sub-menu-item ${split[3] === 'indicator'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>KPI Indikator</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/kpi/variable/data`} className={` sub-menu-item ${split[3] === 'variable'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>KPI Variabel</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/kpi/score/data`} className={` sub-menu-item ${split[3] === 'score'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>KPI Skor</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
                
            { children }
        </Layouts>
    )
}

export default Kpi
